export default __webpack_public_path__ + "static/media/infinity_gainz.d4420cdd.png";